"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChatLogic = void 0;
var rdflib_1 = require("rdflib");
var ns_1 = require("../util/ns");
var utils_1 = require("../util/utils");
var CHAT_LOCATION_IN_CONTAINER = "index.ttl#this";
function createChatLogic(store, profileLogic) {
    var ns = ns_1.ns;
    function setAcl(chatContainer, me, invitee) {
        return __awaiter(this, void 0, void 0, function () {
            var chatAclDoc, aclBody;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Some servers don't present a Link http response header
                    // if the container doesn't exist yet, so refetch the container
                    // now that it has been created:
                    return [4 /*yield*/, store.fetcher.load(chatContainer)];
                    case 1:
                        // Some servers don't present a Link http response header
                        // if the container doesn't exist yet, so refetch the container
                        // now that it has been created:
                        _a.sent();
                        chatAclDoc = store.any(chatContainer, new rdflib_1.NamedNode("http://www.iana.org/assignments/link-relations/acl"));
                        if (!chatAclDoc) {
                            throw new Error("Chat ACL doc not found!");
                        }
                        aclBody = "\n            @prefix acl: <http://www.w3.org/ns/auth/acl#>.\n            <#owner>\n            a acl:Authorization;\n            acl:agent <".concat(me.value, ">;\n            acl:accessTo <.>;\n            acl:default <.>;\n            acl:mode\n                acl:Read, acl:Write, acl:Control.\n            <#invitee>\n            a acl:Authorization;\n            acl:agent <").concat(invitee.value, ">;\n            acl:accessTo <.>;\n            acl:default <.>;\n            acl:mode\n                acl:Read, acl:Append.\n            ");
                        return [4 /*yield*/, store.fetcher.webOperation("PUT", chatAclDoc.value, {
                                data: aclBody,
                                contentType: "text/turtle",
                            })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function addToPrivateTypeIndex(chatThing, me) {
        return __awaiter(this, void 0, void 0, function () {
            var privateTypeIndex, reg, ins;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        privateTypeIndex = store.any(me, ns.solid("privateTypeIndex"));
                        if (!privateTypeIndex) {
                            throw new Error("Private type index not found!");
                        }
                        return [4 /*yield*/, store.fetcher.load(privateTypeIndex)];
                    case 1:
                        _a.sent();
                        reg = (0, utils_1.newThing)(privateTypeIndex);
                        ins = [
                            (0, rdflib_1.st)(reg, ns.rdf("type"), ns.solid("TypeRegistration"), privateTypeIndex.doc()),
                            (0, rdflib_1.st)(reg, ns.solid("forClass"), ns.meeting("LongChat"), privateTypeIndex.doc()),
                            (0, rdflib_1.st)(reg, ns.solid("instance"), chatThing, privateTypeIndex.doc()),
                        ];
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                store.updater.update([], ins, function (_uri, ok, errm) {
                                    if (!ok) {
                                        reject(new Error(errm));
                                    }
                                    else {
                                        resolve(null);
                                    }
                                });
                            })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function findChat(invitee) {
        return __awaiter(this, void 0, void 0, function () {
            var me, podRoot, chatContainer, exists, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, profileLogic.loadMe()];
                    case 1:
                        me = _a.sent();
                        return [4 /*yield*/, profileLogic.getPodRoot(me)];
                    case 2:
                        podRoot = _a.sent();
                        chatContainer = (0, utils_1.determineChatContainer)(invitee, podRoot);
                        exists = true;
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, store.fetcher.load(new rdflib_1.NamedNode(chatContainer.value + "index.ttl#this"))];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        exists = false;
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/, { me: me, chatContainer: chatContainer, exists: exists }];
                }
            });
        });
    }
    function createChatThing(chatContainer, me) {
        return __awaiter(this, void 0, void 0, function () {
            var created;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mintNew({
                            me: me,
                            newBase: chatContainer.value,
                        })];
                    case 1:
                        created = _a.sent();
                        return [2 /*return*/, created.newInstance];
                }
            });
        });
    }
    function mintNew(newPaneOptions) {
        var kb = store;
        var updater = kb.updater;
        if (newPaneOptions.me && !newPaneOptions.me.uri) {
            throw new Error("chat mintNew:  Invalid userid " + newPaneOptions.me);
        }
        var newInstance = (newPaneOptions.newInstance =
            newPaneOptions.newInstance ||
                kb.sym(newPaneOptions.newBase + CHAT_LOCATION_IN_CONTAINER));
        var newChatDoc = newInstance.doc();
        kb.add(newInstance, ns.rdf("type"), ns.meeting("LongChat"), newChatDoc);
        kb.add(newInstance, ns.dc("title"), "Chat channel", newChatDoc);
        kb.add(newInstance, ns.dc("created"), (0, rdflib_1.term)(new Date(Date.now())), newChatDoc);
        if (newPaneOptions.me) {
            kb.add(newInstance, ns.dc("author"), newPaneOptions.me, newChatDoc);
        }
        return new Promise(function (resolve, reject) {
            updater === null || updater === void 0 ? void 0 : updater.put(newChatDoc, kb.statementsMatching(undefined, undefined, undefined, newChatDoc), "text/turtle", function (uri2, ok, message) {
                if (ok) {
                    resolve(__assign(__assign({}, newPaneOptions), { newInstance: newInstance }));
                }
                else {
                    reject(new Error("FAILED to save new chat channel at: " + uri2 + " : " + message));
                }
            });
        });
    }
    /**
     * Find (and optionally create) an individual chat between the current user and the given invitee
     * @param invitee - The person to chat with
     * @param createIfMissing - Whether the chat should be created, if missing
     * @returns null if missing, or a node referring to an already existing chat, or the newly created chat
     */
    function getChat(invitee, createIfMissing) {
        if (createIfMissing === void 0) { createIfMissing = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, me, chatContainer, exists, chatThing;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, findChat(invitee)];
                    case 1:
                        _a = _b.sent(), me = _a.me, chatContainer = _a.chatContainer, exists = _a.exists;
                        if (exists) {
                            return [2 /*return*/, new rdflib_1.NamedNode(chatContainer.value + CHAT_LOCATION_IN_CONTAINER)];
                        }
                        if (!createIfMissing) return [3 /*break*/, 6];
                        return [4 /*yield*/, createChatThing(chatContainer, me)];
                    case 2:
                        chatThing = _b.sent();
                        return [4 /*yield*/, sendInvite(invitee, chatThing)];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, setAcl(chatContainer, me, invitee)];
                    case 4:
                        _b.sent();
                        return [4 /*yield*/, addToPrivateTypeIndex(chatThing, me)];
                    case 5:
                        _b.sent();
                        return [2 /*return*/, chatThing];
                    case 6: return [2 /*return*/, null];
                }
            });
        });
    }
    function sendInvite(invitee, chatThing) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var inviteeInbox, inviteBody, inviteResponse, locationStr;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, store.fetcher.load(invitee.doc())];
                    case 1:
                        _b.sent();
                        inviteeInbox = store.any(invitee, ns.ldp("inbox"), undefined, invitee.doc());
                        if (!inviteeInbox) {
                            throw new Error("Invitee inbox not found! ".concat(invitee.value));
                        }
                        inviteBody = "\n        <> a <http://www.w3.org/ns/pim/meeting#LongChatInvite> ;\n        ".concat(ns.rdf("seeAlso"), " <").concat(chatThing.value, "> .\n        ");
                        return [4 /*yield*/, ((_a = store.fetcher) === null || _a === void 0 ? void 0 : _a.webOperation("POST", inviteeInbox.value, {
                                data: inviteBody,
                                contentType: "text/turtle",
                            }))];
                    case 2:
                        inviteResponse = _b.sent();
                        locationStr = inviteResponse === null || inviteResponse === void 0 ? void 0 : inviteResponse.headers.get("location");
                        if (!locationStr) {
                            throw new Error("Invite sending returned a ".concat(inviteResponse === null || inviteResponse === void 0 ? void 0 : inviteResponse.status));
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        setAcl: setAcl,
        addToPrivateTypeIndex: addToPrivateTypeIndex,
        findChat: findChat,
        createChatThing: createChatThing,
        getChat: getChat,
        sendInvite: sendInvite,
        mintNew: mintNew
    };
}
exports.createChatLogic = createChatLogic;
//# sourceMappingURL=chatLogic.js.map